const Deeplinks = () => import('@/modules/deeplinks');

export default [
  {
    path: '/deeplinks',
    name: 'deeplinks',
    component: Deeplinks,
    props: true,
    meta: {
      isAvaliableInMenu: true,
      navbarTitle: 'Deeplinks',
      menuData: {
        title: 'Deeplinks',
        id: 'deeplinkSidebar',
        section: 'Marketing',
        icon: 'link',
      },
    },
  },
];
